module.exports = __webpack_public_path__ + "static/media/coacherai.387dbf10.png";